const ISSUED = 'Emitida';
const PAID = 'Pagada';
const CANCELED = 'Anulada';

module.exports = {
  ISSUED,
  PAID,
  CANCELED,
};
